let demoInfo = null;
export const setDemoInfo = (d) => { demoInfo = d; };
export const isDemo = () => !!demoInfo;
export const DEMO_MSG = "Nella demo questa azione è disattivata";
